import withRestaurantStore from '@discover-data/stores/restaurant/withStore';
import RestaurantStoreDevMenu from '@discover-components/restaurant/devMenu';
import SiteLayout, { type SiteLayoutProps } from './SiteLayout';

function CitySiteLayout(props: SiteLayoutProps) {
  return (
    <>
      <SiteLayout {...props} />
      <RestaurantStoreDevMenu />
    </>
  );
}

// SiteLayout's modal outlet must share the list's store when displaying the map.
export default withRestaurantStore(CitySiteLayout, 'City Page Store');
